import { DEFAULT_DAILY_RATE } from '../../constants';
import { uid } from '../../utils/format';

// Ligne vendue vierge d'une affaire (forfait par brique, TJM par défaut).
export function blankDealLine() {
  return {
    id: uid(),
    facturation: 'forfait_brique',
    nom: '',
    tjm: DEFAULT_DAILY_RATE,
    jours_min: '',
    jours_max: '',
    budget_min: '',
    budget_max: '',
    budget_vendu: '',
    jours_vendus: '',
    unite_vendu: 'jours',
    nb_devs_estime: '',
    nb_devs_vendu: '',
    tjm_vendu: '',
    engagement_mois_estime: '',
    engagement_mois_vendu: '',
    heures_estime: '',
    heures_unite_estime: 'heures_mois',
    taux_horaire_estime: '',
    heures_vendu: '',
    heures_unite_vendu: 'heures_mois',
    taux_horaire_vendu: '',
    montant_mensuel: '',
    montant_mensuel_estime: '',
    correctif_qte: '',
    correctif_unite: 'heures_mois',
    evolutif_qte: '',
    evolutif_unite: 'jours_an',
    date_debut_prevue: '',
    date_fin_prevue: '',
  };
}

// Lignes d'une affaire créée depuis un appel d'offres : le budget estimé de l'AO devient une ligne
// forfait par brique (fourchette min = max). Sans ligne, le potentiel de l'affaire vaudrait 0 € et
// la fiche s'ouvrirait sur une ligne vide.
export function tenderBudgetLines(nom, budget) {
  const amount = Number(budget);
  if (!budget || !(amount > 0)) return [];
  return [{ ...blankDealLine(), nom, budget_min: amount, budget_max: amount }];
}
